import { Image, notDesktop, styled, useIsMobile } from '@obvio/app'
import { motion, useScroll, useTransform } from 'framer-motion'

import { FadeIn } from '../FadeIn'

import type { ImageAsset } from '@obvio/app'
import type { ReactElement } from 'react'

const Wrap = styled.div`
  height: 42rem;
  width: 60%;
  margin: 0 auto;
  @media ${notDesktop} {
    height: 21rem;
  }
`

const MotionWrap = motion(Wrap)

type ArtistFeaturedPhotoProps = {
  image: ImageAsset
}

export function ArtistFeaturedPhoto({
  image,
}: ArtistFeaturedPhotoProps): ReactElement {
  const { scrollY } = useScroll()
  const isMobile = useIsMobile(1024)
  const height = useTransform(
    scrollY,
    [0, 750],
    isMobile ? ['21rem', '40rem'] : ['42rem', '50rem'],
  ) as any
  const width = useTransform(scrollY, [0, 750], ['60%', '100%']) as any
  return (
    <FadeIn>
      <MotionWrap style={{ height, width }}>
        <Image img={image} sizes="100vw" />
      </MotionWrap>
    </FadeIn>
  )
}
